import { timeToSeconds } from "./date";

// Converte video.toc in capitoli con inizio/fine in secondi
export const getChapters = video =>
	(video?.toc || [])
	.filter(c => c.sections?.length)
	.map((c, i) => ({
		index: i,
		title: c.title,
		start: timeToSeconds(c.sections[0].start),
		end: timeToSeconds(c.sections[c.sections.length - 1].end),
		sections: c.sections.map(s => ({
			title: s.title,
			start: timeToSeconds(s.start),
			end: timeToSeconds(s.end)
		}))
	}));

// Indice dell'ultimo elemento già iniziato al tempo dato, -1 se nessuno
export const getActiveIndex = (items, time) => {
	if (time === null || time === undefined) return -1;
	let active = -1;
	items.forEach((item, i) => { if (item.start <= time) active = i; });
	return active;
};
